(()=>{
  const setup=root=>{
    root.querySelectorAll('[data-tb-buybox]').forEach(section=>{
      if(section.tbBuyboxObserver)return;
      const mainButton=()=>section.querySelector('product-form button[name="add"][type="submit"]');
      const unavailable=button=>!button||button.disabled||button.getAttribute('aria-disabled')==='true';
      const forwardSticky=event=>{
        const sticky=event.target.closest('sticky-atc .main-product-atc');
        if(!sticky||!section.contains(sticky))return;
        event.preventDefault();event.stopImmediatePropagation();
        const main=mainButton();
        if(!unavailable(main))main.click();
      };
      section.addEventListener('click',forwardSticky,true);
      section.tbBuyboxCleanup=()=>section.removeEventListener('click',forwardSticky,true);
      const apply=()=>{
        const main=mainButton();
        const sticky=section.querySelector('sticky-atc .main-product-atc');
        if(main&&sticky){
          const disabled=unavailable(main);
          if(sticky.disabled!==disabled)sticky.disabled=disabled;
          const busy=main.classList.contains('loading')||main.getAttribute('aria-disabled')==='true';
          if(sticky.classList.contains('loading')!==busy)sticky.classList.toggle('loading',busy);
          const label=main.querySelector('.main-atc__label__text');
          const stickyLabel=sticky.querySelector('.sticky-atc__label__text');
          if(label&&stickyLabel&&stickyLabel.textContent!==label.textContent.trim())stickyLabel.textContent=label.textContent.trim();
        }
        const choices=[['9060c34b-e896-4524-9ecc-ec54a90c537d',section.dataset.buyboxSingle,section.dataset.buyboxSingleDetail],['IxBW',section.dataset.buyboxDuo,section.dataset.buyboxDuoDetail]];
        choices.forEach(([id,title,detail])=>{
          const bar=section.querySelector('[data-deal-bar-id="'+id+'"]');if(!bar)return;
          const setText=(el,text)=>{if(!el||!text)return;const node=[...el.childNodes].find(n=>n.nodeType===Node.TEXT_NODE);if(node&&node.nodeValue!==text)node.nodeValue=text;};
          setText(bar.querySelector('.kaching-bundles__bar-title'),title);
          if(id==='IxBW')setText(bar.querySelector('.kaching-bundles__bar-label'),section.dataset.buyboxBadge);
          const line=bar.querySelector('.kaching-bundles__bar-second-line');if(line&&detail){let note=line.querySelector('.tb-buybox-detail');if(!note){note=document.createElement('span');note.className='tb-buybox-detail';line.append(note);}if(note.textContent!==detail)note.textContent=detail;}
        });
      };
      let scheduled=false;
      const observer=new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;apply();});});
      observer.observe(section,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});section.tbBuyboxObserver=observer;apply();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(document),{once:true});else setup(document);
  document.addEventListener('shopify:section:load',e=>setup(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-tb-buybox]').forEach(s=>{s.tbBuyboxObserver?.disconnect();s.tbBuyboxCleanup?.();delete s.tbBuyboxObserver;}));
})();


// Calendar arithmetic uses the merchant's time zone and UTC dates to avoid DST shifts.
if (!customElements.get('tb-delivery-estimate')) {
  customElements.define('tb-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      this.update();
      this.timer = setInterval(() => this.update(), 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    estimate(now = new Date()) {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.dataset.timezone || 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric'
      }).formatToParts(now);
      const value = type => Number(parts.find(part => part.type === type).value);
      const date = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
      const processing = Number(this.dataset.processing), transit = Number(this.dataset.transit);
      if (!Number.isInteger(processing) || processing < 0 || processing > 7 || !Number.isInteger(transit) || transit < 1 || transit > 21) return null;
      let remaining = processing + transit;
      while (remaining > 0) {
        date.setUTCDate(date.getUTCDate() + 1);
        if (this.dataset.dayType !== 'business' || (date.getUTCDay() !== 0 && date.getUTCDay() !== 6)) remaining--;
      }
      return date;
    }
    update() {
      try {
        const date = this.estimate(), time = this.querySelector('time');
        if (!date || !time) { this.hidden = true; return; }
        const iso = date.toISOString().slice(0, 10);
        if (time.dateTime !== iso) {
          time.dateTime = iso;
          time.textContent = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }).format(date);
        }
        this.hidden = false;
      } catch (_) { this.hidden = true; }
    }
  });
}

(() => {
  const selector = '[data-deal-block-id="79d56353-2cde-4ac2-a465-69688fcb0c63"]:is([data-ab-test-variant-id="7437b373-4447-47fb-8e68-271f170ea681"], :not([data-ab-test-variant-id]))';
  const ids = ['f9619223-7b5a-4b08-aab8-28464bc1cd65', '1j0N'];
  const giftingSelector='[data-deal-block-id="ee5d0004-92ae-488b-b5a0-fb8c0afd117c"]';
  const update = () => {
    observer.disconnect();
    document.querySelectorAll('.th-offer').forEach(root => {
      if (!root.matches(selector+','+giftingSelector)) {
        root.classList.remove('th-offer');
        root.querySelectorAll('.th-offer-tabs, .th-offer-quantities').forEach(node=>node.remove());
        root.querySelectorAll('.th-offer-product, .th-offer-quantity').forEach(node => node.remove());
      }
    });
    document.querySelectorAll(selector+','+giftingSelector).forEach(root => {
      const gifting=root.matches(giftingSelector);
      const activeIds=gifting?["d12ecb04-1da1-4e08-b954-12deb8e41556","f70e7f7e-dd55-48b4-b787-8bceac8f4eca","RiCH","wUgz"]:ids;
      const bars = activeIds.map(id => root.querySelector('[data-deal-bar-id="' + id + '"]'));
      if (bars.some(bar => !bar) || !bars.some(bar => bar.classList.contains('kaching-bundles__bar--selected'))) {
        root.classList.remove('th-offer');
        root.querySelectorAll('.th-offer-tabs, .th-offer-quantities').forEach(node=>node.remove());
        root.querySelectorAll('.th-offer-product, .th-offer-quantity').forEach(node => node.remove());
        return;
      }
      let tabs = root.querySelector('.th-offer-tabs');
      if (!tabs) {
        tabs = document.createElement('div');
        tabs.className = 'th-offer-tabs';
        bars.slice(0,2).forEach((bar, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'th-offer-tab';
          button.textContent = gifting&&index===1?'BOGO 50% OFF & More':bar.querySelector('.kaching-bundles__bar-title').textContent.trim();
          button.addEventListener('click', event => {
            event.preventDefault();event.stopPropagation();
            root.querySelector('[data-deal-bar-id="' + activeIds[gifting&&index===1?(Number(root.dataset.lastBundle)||1):index] + '"] input[type=radio]')?.click();
          });
          if (index === 1) {
            const badge = document.createElement('span');
            badge.className = 'th-offer-badge';
            badge.textContent = gifting?'Buy more, save more':'BOGO 50% Off';
            button.append(badge);
          }
          tabs.append(button);
        });
        root.querySelector('.kaching-bundles__bars').before(tabs);
      }
      const selected=bars.findIndex(bar=>bar.classList.contains('kaching-bundles__bar--selected'));
      tabs.children[0].setAttribute('aria-pressed',String(selected===0));tabs.children[1].setAttribute('aria-pressed',String(selected>0));
      if(gifting){
        if(selected>0)root.dataset.lastBundle=String(selected);
        let quantities=root.querySelector('.th-offer-quantities');
        if(!quantities){quantities=document.createElement('div');quantities.className='th-offer-quantities';const label=document.createElement('span');label.textContent='Choose your brush quantity';quantities.append(label);bars.slice(1).forEach((bar,i)=>{const button=document.createElement('button');button.type='button';button.textContent=(i+2)+' brushes';button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();root.querySelector('[data-deal-bar-id="'+activeIds[i+1]+'"] input[type=radio]')?.click()});quantities.append(button)});tabs.after(quantities)}
        quantities.hidden=selected===0;quantities.querySelectorAll('button').forEach((button,i)=>button.setAttribute('aria-pressed',String(selected===i+1)));
      }
      bars.forEach((bar, index) => {
        const content = bar.querySelector('.kaching-bundles__bar-content-left');
        if (!content.querySelector('.th-offer-product')) {
          const product = document.createElement('span');
          product.className = 'th-offer-product';
          product.textContent = gifting&&index>0?(index+1)+' × TheraBrush®':'TheraBrush®';
          const detail = document.createElement('span');
          detail.className = 'th-offer-quantity';
          detail.textContent = index === 0 ? 'Your daily hair-care ritual' : gifting?'Save on '+(index+1)+', the perfect gift 🎁':'Save on 2, the perfect gift 🎁';
          content.append(product, detail);
        }
        bar.querySelectorAll('.kaching-bundles__upsell').forEach(upsell => {
          const toggle = upsell.querySelector('.kaching-bundles__upsell__checkbox');
          if (!toggle) return;
          toggle.setAttribute('aria-label', upsell.querySelector('.kaching-bundles__upsell__text').textContent.trim() + ', ' + upsell.querySelector('.kaching-bundles__upsell__price').textContent.trim());
          toggle.setAttribute('role', 'switch');
          toggle.setAttribute('aria-checked', String(toggle.classList.contains('kaching-bundles__upsell__checkbox--selected')));
        });
      });
      root.classList.add('th-offer');
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'data-ab-test-variant-id'] });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();

/* Independent quantity-layout experiment; original offers remain untouched. */
(() => {
  const selector = '[data-deal-block-id="89423bcc-c422-45f4-a7af-5ca8855e0e98"]';
  const assetBase = document.currentScript?.src || [...document.scripts].find(s => s.src.includes('/tb-buybox.js'))?.src;
  const text = (bar, cls) => bar.querySelector(cls)?.textContent.trim() || '';
  const amount = value => {
    const normalized = value.replace(/[^0-9.,]/g, '');
    const decimal = normalized.lastIndexOf(',') > normalized.lastIndexOf('.') && /,\d{2}$/.test(normalized);
    return Number(decimal ? normalized.replace(/\./g, '').replace(',', '.') : normalized.replace(/,/g, ''));
  };
  const update = () => {
    observer.disconnect();
    document.querySelectorAll(selector).forEach(root => {
      const bars = [...root.querySelectorAll('[data-deal-bar-id]')];
      const selected = bars.findIndex(bar => bar.classList.contains('kaching-bundles__bar--selected'));
      if (bars.length !== 4 || selected < 0) return;
      let ui = root.querySelector('.th-quantity-ui');
      if (!ui) {
        ui = document.createElement('div'); ui.className = 'th-quantity-ui';
        ui.innerHTML = '<div class="th-quantity-heading">Buy more, save more<svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-left:7px"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13M12 8H7.5A2.5 2.5 0 1 1 10 5.5L12 8Zm0 0h4.5A2.5 2.5 0 1 0 14 5.5L12 8Z"/></svg></div><div class="th-quantity-deals" aria-label="Bundle savings"></div><div class="th-quantity-options" role="group" aria-label="Brush quantity"></div><div class="th-quantity-card" aria-live="polite"><div class="th-quantity-product"><div class="th-quantity-photo"><img alt="TheraBrush" class="th-quantity-brush-image"><span class="th-quantity-multiplier"></span></div><strong class="th-quantity-product-name">TheraBrush®</strong></div><div class="th-quantity-summary"><span class="th-offer-total-label">Offer total</span><strong class="th-quantity-price"></strong></div><div class="th-offer-included"><img class="th-offer-tonic-image" alt=""><div class="th-offer-tonic-copy"><strong class="th-offer-tonic-name"></strong><span class="th-offer-tonic-value"></span></div><strong class="th-offer-free-price">FREE</strong></div><div class="th-offer-value-line"><span>Brush + tonic value <s class="th-quantity-was"></s></span><span class="th-quantity-saving"></span></div></div>';
        const choose = (i, event) => {
          event.preventDefault(); event.stopPropagation();
          root.querySelectorAll('[data-deal-bar-id]')[i]?.querySelector('input[type="radio"]')?.click();
        };
        bars.forEach((bar, i) => {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = String(i + 1);
          button.setAttribute('aria-label', (i + 1) + (i ? ' brushes' : ' brush'));
          button.addEventListener('click', e => choose(i, e));
          ui.querySelector('.th-quantity-options').append(button);
          if (i) {
            const deal = document.createElement('button'); deal.type = 'button';
            deal.addEventListener('click', e => choose(i, e));
            ui.querySelector('.th-quantity-deals').append(deal);
          }
        });
        root.querySelector('.kaching-bundles__bars').before(ui);
      }
      bars.forEach((bar, i) => {
        const giftImage = bar.querySelector('.kaching-bundles__free-gift__image');
        if (giftImage && assetBase) {
          const giftSrc = new URL('th-tonic-gift-' + (i + 1) + '.png', assetBase).href;
          if (giftImage.src !== giftSrc) giftImage.src = giftSrc;
          giftImage.removeAttribute('srcset');
          giftImage.alt = (i + 1) + ((i === 0) ? ' free bottle of Hair Growth Tonic' : ' free bottles of Hair Growth Tonic');
          giftImage.width = 100; giftImage.height = 100;
        }
        const price = amount(text(bar, '.kaching-bundles__bar-price'));
        const compare = amount(text(bar, '.kaching-bundles__bar-full-price'));
        const saving = compare > price ? Math.floor((1 - price / compare) * 100) : 0;
        ui.querySelector('.th-quantity-options').children[i].setAttribute('aria-pressed', String(i === selected));
        if (i) {
          const deal = ui.querySelector('.th-quantity-deals').children[i - 1];
          const singlePrice = amount(text(bars[0], '.kaching-bundles__bar-price'));
          const tierSaving = singlePrice > 0 ? Math.round((1 - price / (singlePrice * (i + 1))) * 100) : 0;
          const secondSaving = singlePrice > 0 ? (1 - (price - singlePrice) / singlePrice) * 100 : 0;
          deal.textContent = i === 1 && Math.abs(secondSaving - 50) < 1
            ? 'Buy 1, get 1 ≈50% off'
            : 'Buy ' + (i + 1) + ' · Save ' + tierSaving + '%';
          deal.title = 'Compared with buying ' + (i + 1) + ' single offers';
          const quantityButton = ui.querySelector('.th-quantity-options').children[i];
          let badge = quantityButton.querySelector('.th-quantity-corner-badge');
          if (!badge) { badge = document.createElement('span'); badge.className = 'th-quantity-corner-badge'; quantityButton.append(badge); }
          badge.textContent = i === 1 ? 'BOGO 50% off' : 'Save ' + tierSaving + '%';
          badge.hidden = !saving;
          deal.hidden = !saving;
          deal.setAttribute('aria-pressed', String(i === selected));
        }
        if (i === selected) {
          const brushImage = bars[0].querySelector('.kaching-bundles__bar-image');
          const image = ui.querySelector('.th-quantity-brush-image');
          if (brushImage && image.getAttribute('src') !== brushImage.getAttribute('src')) image.setAttribute('src', brushImage.getAttribute('src'));
          const multiplier = ui.querySelector('.th-quantity-multiplier');
          multiplier.textContent = '×' + (i + 1);
          multiplier.hidden = i === 0;

          const tonic = ui.querySelector('.th-offer-tonic-image');
          if (giftImage) { tonic.src = giftImage.src; tonic.alt = giftImage.alt; }
          ui.querySelector('.th-offer-tonic-name').textContent = (i ? (i + 1) + ' × ' : '') + 'Hair Growth Tonic';
          ui.querySelector('.th-offer-tonic-value').textContent = text(bar, '.kaching-bundles__free-gift__full-price') + ' value · Yours free';
          ui.querySelector('.th-quantity-price').textContent = text(bar, '.kaching-bundles__bar-price');
          ui.querySelector('.th-quantity-was').textContent = text(bar, '.kaching-bundles__bar-full-price');
          const valueSaving = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(Math.max(0, compare - price));
          ui.querySelector('.th-quantity-saving').textContent = 'Save ' + valueSaving;
          ui.querySelector('.th-quantity-saving').title = 'Total savings against the brush + tonic value shown';
          ui.querySelector('.th-quantity-saving').hidden = !saving;
        }
      });
      root.classList.add('th-quantity-offer');
    });
    observer.observe(document.body, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['class']});
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return; queued = true;
    requestAnimationFrame(() => {queued = false; update();});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, {once:true});
  else update();
})();

// Select the existing native two-brush offer for Hair Revival visitors.
(()=>{const requested=new URLSearchParams(location.search).get('tb_offer');if(!['1','2'].includes(requested))return;let done=false;const select=()=>{const button=document.querySelector('.th-quantity-options button[aria-label="'+(requested==='1'?'1 brush':'2 brushes')+'"]');if(!button||done)return;done=true;button.click();button.closest('[data-tb-buybox]')?.scrollIntoView({block:'start'});observer.disconnect()};const observer=new MutationObserver(select);observer.observe(document.documentElement,{childList:true,subtree:true});select();setTimeout(()=>observer.disconnect(),20000)})();
